// global-shim.js
if (typeof global === 'undefined') {
    /* @ts-ignore */
    window.global = {};
}